import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  alt: "favicon",
  src: "/favicon.svg",
  class: "icon",
  style: {"margin-right":"5px"}
}, null, -1)
const _hoisted_2 = { class: "me-2" }
const _hoisted_3 = { class: "form-inline my-2 my-lg-0" }

import EnvBadge from "@/shared/components/misc/EnvBadge.vue";
import LogoutButton from "@/auth/components/LogoutButton.vue";
import SimulationGroupBadge from "@/admin/components/SimulationGroupBadge.vue";
import NavBar from "@/shared/components/nav/NavBar.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'PageHeader',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(NavBar, null, {
    brand: _withCtx(() => [
      _createVNode(_component_router_link, {
        class: "navbar-brand",
        to: { name: 'home' }
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createTextVNode(" paperoffice "),
          _createVNode(EnvBadge)
        ]),
        _: 1
      })
    ]),
    right: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(SimulationGroupBadge)
      ]),
      _createElementVNode("form", _hoisted_3, [
        _createVNode(LogoutButton)
      ])
    ]),
    _: 1
  }))
}
}

})